import React from 'react'
import Navbar from '../../components/common/Navbar'
import Footer from '../../components/common/Footer'
import privacyNotice from '../../assets/images/privacyNotice.png'

const UserPrivactNoticePage = () => {
    return (
        <>
        <Navbar />
        <div className="flex flex-col bg-white lg:p-10 p-5 gap-5  lg:mt-18 mt-14">
            <div className='flex flex-row justify-center items-center mb-10'>
                <img src={privacyNotice} alt='privact notice' className='lg:w-[248px] lg:h-[463px] w-32' />
            </div>
            <h1 className='md:text-[55px] text-[23px] font-bold'>Privacy Statement</h1>
            <ul className='md:text-[22px] text-sm'>
                <li>
                    ProSynergy Inc. upholds a strong commitment to the protection of personal information. Data collected is handled responsibly and processed in accordance with applicable privacy laws, solely for purposes related to business operations and service delivery.                
                </li>
                <li className='py-6'>
                    All information is managed with strict confidentiality, shared only with authorized entities when necessary, and retained only for as long as required by legal or operational needs. Security measures are in place to safeguard all collected data against unauthorized access or misuse.
                </li>
                <li>
                    For inquiries or concerns, please contact our Data Protection Officer, Ms. Gladys Manalili at 0917 631 5944.
                </li>
            </ul> 
        </div>
        <Footer />
    </>
    )
}

export default UserPrivactNoticePage
